import { render, staticRenderFns } from "./RideitChangeRequests.vue?vue&type=template&id=5901bde4&scoped=true"
import script from "./RideitChangeRequests.vue?vue&type=script&lang=ts"
export * from "./RideitChangeRequests.vue?vue&type=script&lang=ts"
import style0 from "./RideitChangeRequests.vue?vue&type=style&index=0&id=5901bde4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5901bde4",
  null
  
)

export default component.exports